import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {
  type QuickLoginStatusParams,
  type QuickLoginStatusResponse,
} from './types'

export async function status(
  _agent: BskyAgent,
  params: QuickLoginStatusParams,
  options?: {signal?: AbortSignal},
): Promise<QuickLoginStatusResponse> {
  return wsocFetch<QuickLoginStatusResponse>(
    xrpcPath('io.trustanchor.quicklogin.status'),
    {body: params, signal: options?.signal},
  )
}
